import { useLocation } from 'react-router-dom';

const LS_KEY = 'araia_lang';
const SUPPORTED = ['it', 'en'];

/**
 * Language resolution rules (source of truth):
 *   1. URL prefix — /en/* → 'en', everything else → 'it'
 *   2. On every render, persist the resolved lang to localStorage so a
 *      future *server-side* redirect (Phase C+) can honour it.
 *
 * `withLang(path)` returns a URL string in the current language. Use it
 * for internal <Link to={...}> so language stickiness Just Works.
 *
 * `toggleLangPath(pathname)` returns the same page under the OTHER
 * language — used by the header <LanguageSwitcher>.
 */

export function getLangFromPath(pathname) {
    if (pathname === '/en' || pathname.startsWith('/en/')) return 'en';
    return 'it';
}

export function useLang() {
    const { pathname } = useLocation();
    const lang = getLangFromPath(pathname);
    // TODO(security): non-sensitive lang preference is fine in localStorage
    // long-term, but the admin JWT token IS sensitive → see adminApi.js
    // TODO(security) block for the httpOnly-cookie migration (D1).
    try {
        localStorage.setItem(LS_KEY, lang);
    } catch (e) {
        console.debug('[useLang] localStorage write failed:', e);
    }
    return lang;
}

export function stripLangPrefix(pathname) {
    if (pathname === '/en') return '/';
    if (pathname.startsWith('/en/')) return pathname.slice(3) || '/';
    return pathname;
}

export function withLang(path, lang) {
    const clean = path.startsWith('/') ? path : `/${path}`;
    if (lang === 'en') {
        if (clean === '/') return '/en';
        return `/en${clean}`;
    }
    return clean;
}

export function toggleLangPath(pathname) {
    const stripped = stripLangPrefix(pathname);
    const other = getLangFromPath(pathname) === 'en' ? 'it' : 'en';
    return { path: withLang(stripped, other), lang: other };
}
